import { Field } from "formik"
import * as Yup from "yup"
import { ERROR_REQUIRED_MESSAGE } from "../constants"

type BasicFieldType = {
  name: RSVPFormFields
  label: string
  required: boolean
  placeholder?: string
}

interface FieldTextType extends BasicFieldType {
  type: "text"
}

type OptionsSelectType = {
  value: string
  label: string
}

interface FieldSelectType extends BasicFieldType {
  type: "select" | "multiple" | "checkbox"
  options: OptionsSelectType[]
}

export type FieldType = FieldTextType | FieldSelectType

export interface FieldItemProps extends BasicFieldType {
  type: "text" | "select" | "multiple" | "checkbox"
  options?: OptionsSelectType[]
}

export type ItemsPerRowType = {
  isFullWidth: boolean
  fields: FieldType[]
}

export type SectionItemsForm = {
  title: string
  items: ItemsPerRowType[]
}

export interface ItemsWrapperProps extends SectionItemsForm {}

/** Form */

export const validationSchema = Yup.object({
  companyName: Yup.string().required(ERROR_REQUIRED_MESSAGE),
  website: Yup.string().required(ERROR_REQUIRED_MESSAGE),
  companyOverview: Yup.string()
    .required(ERROR_REQUIRED_MESSAGE)
    .max(150, "Maximum 150 characters allowed")
    .matches(/^[\s\S]{0,150}$/, "Maximum 150 characters allowed"),
  primaryContactName: Yup.string().required(ERROR_REQUIRED_MESSAGE),
  primaryContactTitle: Yup.string().required(ERROR_REQUIRED_MESSAGE),
  primaryContactEmail: Yup.string().email("Please enter a valid email address").required(ERROR_REQUIRED_MESSAGE),
  primaryContactPhone: Yup.string().required(ERROR_REQUIRED_MESSAGE),
  address: Yup.string().required(ERROR_REQUIRED_MESSAGE),
  partnershipCommunity: Yup.string().required(ERROR_REQUIRED_MESSAGE),
  experienceWorking: Yup.string().required(ERROR_REQUIRED_MESSAGE),
  integratePVPlatform: Yup.string().required(ERROR_REQUIRED_MESSAGE),
  clientOpportunities: Yup.string().required(ERROR_REQUIRED_MESSAGE),
  coMarketingOpportunities: Yup.string().required(ERROR_REQUIRED_MESSAGE),
  referencesPastClients: Yup.string().required(ERROR_REQUIRED_MESSAGE),
  additionalInformation: Yup.string().nullable(),
  hospitalityOperationsConsulting: Yup.string().nullable(),
  financialBusinessPlanning: Yup.string().nullable(),
  marketingBrandStrategy: Yup.string().nullable(),
  franchiseExpansionConsulting: Yup.string().nullable(),
  technologyDigitalStrategy: Yup.string().nullable(),
  projectManagementImplementation: Yup.string().nullable(),
  customITSolutionsEngineering: Yup.string().nullable(),
  otherSpecialization: Yup.string().nullable(),
})

export type RSVPFormValues = Yup.InferType<typeof validationSchema>
export type RSVPFormFields = keyof RSVPFormValues
